import { createContext } from 'react';

import type { CellHighlightTarget } from './cell-highlight.types';

export interface CellHighlightRegistrationApi {
  registerTarget: (key: string, target: CellHighlightTarget) => void;
  unregisterTarget: (key: string) => void;
}

export const CellHighlightRegistrationApiContext =
  createContext<CellHighlightRegistrationApi | null>(null);
export const CellHighlightRegistrationTargetsContext = createContext<CellHighlightTarget[]>([]);

export const cellHighlightRegistrationTargetKey = (rowId: string, columnId: string): string =>
  `${rowId}:${columnId}`;
